import { useState, useCallback } from "react";

import { toast } from "sonner";

import { useSupabaseSession } from "~/context/SupabaseSessionContext";
import { API_URL } from "~/lib/constants";

import { useApiClient } from "./use-api-client";

export const useSessionSharingToken = (sessionId: string, useAdmin = false) => {
    const { token } = useSupabaseSession();
    const [isLoading, setIsLoading] = useState(false);
    const [sharingToken, setSharingToken] = useState<string | null>(null);
    const apiClient = useApiClient();

    const createSharingToken = useCallback(
        async (nonExpiring = false) => {
            if (!apiClient.post) {
                return;
            }

            setIsLoading(true);
            const url = useAdmin ? `/admin/sessionToken` : `/session`;

            try {
                const response = await apiClient.post(url, {
                    sessionId,
                    nonExpiring,
                });
                if (response.ok) {
                    const data = await response.json();
                    setSharingToken(data.token);
                    return data.token;
                } else {
                    toast.error("Failed to create sharing link");
                }
            } catch (error) {
                toast.error("Failed to create sharing link");
            } finally {
                setIsLoading(false);
            }
        },
        [apiClient, sessionId, useAdmin],
    );

    return { isLoading, createSharingToken, sharingToken };
};
